import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import YouTube from 'react-youtube';
import { generateImageUrl } from '../../../utils/webp';
import {
  VideoCotainer, VideoInner, TextContainer, VideoWrapper, VideoModal, Overlay,
} from '../styles/video.style';

const propTypes = {
  posterImageOverwrite: PropTypes.object,
  youtubeVideoId: PropTypes.string,
  displayTitle: PropTypes.string,
  subtitle: PropTypes.string,
  openContentInModal: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  isVideoOnScreen: PropTypes.bool,
};

const defaultProps = {
  posterImageOverwrite: {
    file: {},
  },
  youtubeVideoId: '',
  displayTitle: '',
  subtitle: '',
  openContentInModal: false,
  hideOverlay: false,
  isVideoOnScreen: true,
};

/**
 * Video Component
 */
class Video extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);

    this.player = null;
    this.state = {
      playVideo: false,
      width: 1400,
    };
  }

  /**
   * componentDidUpdate
   * @param {object} prevProps prev props
   */
  componentDidUpdate(prevProps) {
    const { isVideoOnScreen } = this.props;
    const { playVideo } = this.state;
    if (prevProps.isVideoOnScreen !== isVideoOnScreen && playVideo) {
      this.pauseVideo();
    }
  }

  /**
   * On ready YouTube
   * @param {object} event response
   */
  onReady(event) {
    this.player = event.target;
  }

  /**
   * Pause the video
   */
  pauseVideo() {
    if (this.player) {
      this.player.pauseVideo();
    }
    this.setState({
      playVideo: false,
    });
  }

  /**
   * Plays the video
   */
  playVideo() {
    const { pauseCarousel } = this.props;
    this.setState({
      playVideo: true,
    });
    if (this.player) {
      this.player.playVideo();
    }
    if (typeof pauseCarousel === 'function') {
      pauseCarousel();
    }
  }

  /**
   * Togles the state of the modal
   */
  toggleModal() {
    const { playVideo } = this.state;
    this.setState({
      playVideo: !playVideo,
    });
  }

  /**
   * Get rect
   * @param {object} element DOM reference
   */
  ref(element) {
    if (element && element.getBoundingClientRect()) {
      const { width: currentWidth } = this.state;
      const { width } = element.getBoundingClientRect();
      if (width !== currentWidth) {
        this.setState({ width });
      }
    }
  }

  /**
   * Renders an iframe with the video
   * @returns {XML} A video component
   */
  render() {
    const {
      youtubeVideoId,
      displayTitle,
      subtitle,
      openContentInModal,
      posterImageOverwrite,
      hideOverlay,
      autoPlay,
      fullBleed,
    } = this.props;

    const { width, playVideo } = this.state;
    const posterImageUrl = posterImageOverwrite && posterImageOverwrite.file ? posterImageOverwrite.file.url : null;
    const showInModal = playVideo && openContentInModal;

    const optimizedUrl = generateImageUrl(posterImageUrl, width);

    const opts = {
      playerVars: {
        autoplay: playVideo || autoPlay ? 1 : 0,
      },
    };

    const videoInline = (
      <YouTube
        videoId={youtubeVideoId}
        mute={autoPlay ? 1 : 0}
        opts={opts}
        onReady={event => this.onReady(event)}
        onPlay={() => this.playVideo()}
        onPause={() => this.pauseVideo()}
      />
    );

    const videoModal = (
      <YouTube
        videoId={youtubeVideoId}
        mute={autoPlay ? 1 : 0}
        opts={opts}
      />
    );

    return (
      <VideoCotainer className={!fullBleed && 'not-fullBleed'}>
        {showInModal && (
          <VideoModal>
            <button type="button" onClick={() => this.toggleModal()}>
              <img src="/images/close.svg" alt="Close Modal" />
            </button>
            {videoModal}
          </VideoModal>
        )}
        <VideoInner
          hideOverlay={hideOverlay || !posterImageUrl}
          className={playVideo && !openContentInModal ? 'hide' : ''}
        >
          { posterImageUrl ? (
            <TextContainer className={playVideo && !openContentInModal ? 'hide' : ''}>
              {displayTitle && (
                <h2>{renderHTML(displayTitle)}</h2>
              )}
              <p>{subtitle}</p>
              { (!playVideo || openContentInModal) && (
                <img className="play-icon" src="/images/playButton.svg" alt="Play Button" />
              )}
            </TextContainer>
          ) : ''}
          <VideoWrapper>
            {!playVideo && (
              <Overlay
                role="button"
                aria-hidden
                onClick={() => this.playVideo()}
              />
            )}
            { posterImageUrl ? (
              <div
                ref={element => this.ref(element)}
                className={`poster-image-wrapper ${(!playVideo || openContentInModal) ? 'is-visible' : 'is-hidden'}`}
              >
                <button type="button" className="playButton" onClick={() => this.playVideo()} />
                <img src={optimizedUrl} alt={displayTitle} />
              </div>
            ) : null}
            {videoInline}
          </VideoWrapper>
        </VideoInner>
      </VideoCotainer>
    );
  }
}

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;

export default Video;



// WEBPACK FOOTER //
// ./src/components/video/components/video.js